import { ProductRole } from "@cabal/shared/domain/session/product/enums.js";
import type { CreferenceLeadingProps } from "./CreferenceLeading";
import type { ReferenceMember } from "./creferenceResolvedEntitySelectors";
import type { CreferenceResolvedEntity } from "./useCreferenceResolvedEntity";

interface CreferenceLeadingMemberFields {
  hasMember: boolean;
  memberColor: string | null;
  memberRole: NonNullable<ReferenceMember>["role"] | null;
}

export function getCreferenceLeadingProps(
  resolvedEntity: CreferenceResolvedEntity,
): Omit<CreferenceLeadingProps, "dataElScope"> {
  const memberFields = getCreferenceLeadingMemberFields(resolvedEntity.member);

  return {
    currentUserImageSrc: resolvedEntity.currentUserImageSrc,
    entityType: resolvedEntity.effectiveEntityType,
    hasMember: memberFields.hasMember,
    isCurrentUserReference: resolvedEntity.isCurrentUserReference,
    memberColor: memberFields.memberColor,
    memberProviderIconPath: resolvedEntity.memberProviderIconPath,
    memberProviderSlug: resolvedEntity.memberProviderSlug,
    memberRole: memberFields.memberRole,
    productIcon: resolvedEntity.productIcon,
    isDecisionProduct: resolvedEntity.product?.role === ProductRole.Decision,
  };
}

function getCreferenceLeadingMemberFields(
  member: ReferenceMember | null,
): CreferenceLeadingMemberFields {
  if (!member) {
    return {
      hasMember: false,
      memberColor: null,
      memberRole: null,
    };
  }

  return {
    hasMember: true,
    memberColor: member.color,
    memberRole: member.role,
  };
}
